/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the SelectService component.
 */
export const SERVICE_SELECT_DATA_IDS = {
  service: `Form field: Service selection`,
};

/**
 * The form field ids used in the SelectService component.
 */
export const SERVICE_SELECT_FORM_IDS = {
  service: `service-id`,
};
